import "./App.css";
import { RouterProvider } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactGA from "react-ga4";
import useCountryCode from "./Hooks/useCountryCode";
import { CommonToast } from "./components/common/Toast";
import { getCountryNameByCountryCode } from "./utils/countriesState";
import { router } from "./router";
import { getConsent, setConsent } from "./utils/cookieConsent";
import { loadKlaviyo } from "./utils/loadKlaviyo";
import { sanitizeAnalyticsPage } from "./utils/sanitizeAnalyticsPath";
import CookieBanner from "./components/CookieBanner";

const stripePromise = loadStripe(
  process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY
);
function App() {
  const { countryCode, loading } = useCountryCode();
  const [accessWeb, setAccessWeb] = useState(true);

  const [consent, setConsentState] = useState(() => getConsent());

  useEffect(() => {
    if (consent?.marketing === true) {
      loadKlaviyo();
    }
  }, [consent]);

  const handleAccept = () => {
    const value = { marketing: true };
    setConsent(value);          // ✅ USED HERE
    setConsentState(value);
  };

  const handleReject = () => {
    const value = { marketing: false };
    setConsent(value);          // ✅ USED HERE
    setConsentState(value);

    // Optional cleanup (defensive)
    document.cookie =
      "__kla_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure";
  };

  useEffect(() => {
    const fetchCountryDetails = async () => {
      if (countryCode && !loading) {
        const countryDetails = await getCountryNameByCountryCode(countryCode);
        CommonToast.info(`Default country set to ${countryDetails.name}`)
      }
    };
    fetchCountryDetails();
  }, [countryCode])

  useEffect(() => {
    const env = process.env.REACT_APP_ENVIRONMENT;

    /* ---- Google Analytics ---- */
    if (env === "testing") {
      ReactGA.initialize("G-BXXHYLC766");
    } else if (env === "production") {
      ReactGA.initialize("G-DEZKKH8MFR");
    }

    // TIP-589 — the raw path/href can carry a lead's capability token
    // (e.g. /company-registration/<token>); never send that to GA.
    const { page, title } = sanitizeAnalyticsPage(
      window.location.pathname,
      window.location.search,
      window.location.origin
    );
    ReactGA.send({ hitType: "pageview", page, title });

    /* ---- Microsoft Clarity ---- */
    if (process.env.REACT_APP_MICROSOFT_CLARITY === "true") {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", "uqe1v51g85");
    }
  }, []);

  useEffect(() => {
    if (localStorage?.getItem("Access_token")) {
      setAccessWeb(false);
    }
  }, []);

  return (
    <>{!consent && (
      <CookieBanner
        onAccept={handleAccept}
        onReject={handleReject}
      />
    )}
      <Elements stripe={stripePromise}>
        <div className="App">
          <RouterProvider router={router} />
          <ToastContainer />
        </div>
      </Elements>
    </>

  );
}

export default App;
